export const AI_TOOL_TYPES = {
  PRODUCTION_ANALYZER: 'productionAnalyzer',
  BUDGET_BREAKDOWN: 'budgetBreakdown',
  OPPORTUNITY_ENGINE: 'opportunityEngine',
}

export const AI_TOOL_TYPE_LABELS = {
  [AI_TOOL_TYPES.PRODUCTION_ANALYZER]: 'Production Analyzer',
  [AI_TOOL_TYPES.BUDGET_BREAKDOWN]: 'Budget Breakdown',
  [AI_TOOL_TYPES.OPPORTUNITY_ENGINE]: 'Opportunity Engine',
}
